import { Text } from '@etiquette-ui/dynamic-table-components';
import styled from 'styled-components';

const ResponsiveText = styled(Text)`
    font-size: 13px;
`;

export default ResponsiveText;